
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Footer from '@/components/Footer';
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Home, AlertCircle } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-brand-deepSpace">
      <div className="star-field"></div>
      <div className="flex-grow flex items-center justify-center py-20">
        <div className="text-center p-10 rounded-lg border border-brand-electricBlue/30 bg-brand-deepSpace/70 backdrop-blur-lg shadow-md relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-brand-electricBlue to-transparent"></div>
          <div className="flex justify-center mb-6">
            <div className="relative">
              <AlertCircle className="h-16 w-16 text-brand-electricBlue" />
              <div className="absolute -inset-1 bg-brand-electricBlue opacity-20 rounded-full blur-sm"></div>
            </div>
          </div>
          
          <h1 className="text-4xl font-bold font-orbit mb-4 gradient-text">404</h1>
          <p className="text-xl text-gray-300 mb-6">Oops! Den siden finnes ikke</p>
          
          <Button 
            asChild
            className="bg-gradient-to-r from-brand-electricBlue to-brand-neonGreen hover:opacity-90 text-brand-deepSpace font-medium shadow-md"
          >
            <Link to="/" className="flex items-center">
              <Home className="mr-2 h-4 w-4" />
              <span>Tilbake til hovedsiden</span>
            </Link>
          </Button>
          
          <div className="cyber-grid absolute inset-0 -z-10 opacity-10"></div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;
